import { z } from "zod";

export const create = z.object({
  value: z.string().min(1, "Required"),
  description: z.string().min(1, "Required"),
  color: z.string().nullish(),
  category: z.string(),
});

export const update = create;
